import React from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { ShieldCheckIcon } from 'lucide-react';
export function PersonalCareServices() {
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-935">
      <Navbar data-id="element-936" />
      <main className="flex-1" data-id="element-937">
        <section className="w-full bg-gray-50 py-16 lg:py-24 border-b border-gray-100" data-id="element-938">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-939">
            <div className="inline-flex items-center gap-2 bg-soft-teal text-accent-teal-dark text-xs font-semibold px-3 py-1.5 rounded-full mb-4" data-id="element-940">
              <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-941" />
              Care Solutions
            </div>
            <h1 className="text-4xl sm:text-5xl font-extrabold text-text-dark tracking-tight mb-6" data-id="element-942">
              Personal Care Services
            </h1>
            <p className="text-lg text-text-muted max-w-2xl mx-auto leading-relaxed" data-id="element-943">
              Compassionate daily living support from vetted PSWs. Bathing,
              grooming, mobility assistance, meal preparation, and companionship
              — all with clinical oversight.
            </p>
          </div>
        </section>
        <div className="max-w-3xl mx-auto px-4 py-16 text-text-muted leading-relaxed space-y-6" data-id="element-944">
          <p data-id="element-945">
            Our Personal Care Services provide compassionate daily living
            support from vetted Personal Support Workers (PSWs). We assist with
            bathing, grooming, mobility, meal preparation, and companionship,
            ensuring individuals receive the care they need to maintain their
            independence and quality of life.
          </p>
          <p data-id="element-946">
            Every care plan is nurse-supervised, ensuring the highest standards
            of clinical quality and patient safety. Our caregivers are trained
            to provide personalized care that meets the unique needs of each
            individual, promoting dignity, respect, and well-being.
          </p>
        </div>
      </main>
      <StickyFooter data-id="element-947" />
    </div>;
}